const VALID_COLUMNS = {
  id: 'id',
  confirmed: 'confirmed',
  name: 'name',
  severity: 'severity',
  cvss: 'cvss3',
  hostnames: 'hostnames',
  create_date: 'date',
  cve: 'cve',
  cwe: 'cwe',
  path: 'path',
  service__name: 'service',
  tool: 'tool',
  status: 'status',
  asset: 'target',
  easeofresolution: 'easeofresolution',
  external_id: 'external_id',
  method: 'method',
  query: 'query',
  status_code: 'status_code',
  website: 'website',
  host__os: 'host_os',
  impact: 'impact'
};

export default VALID_COLUMNS;
